@if (open()) {
    <app-generic-multiple-selection
        [allItems]="allUsers"
        [selectedItems]="tempValue"
        (applySelection)="onApply($event)"
        (cancelSelection)="onCancel()"
        [loading]="isLoading()"
        [(isOpen)]="isOpen"
        [config]="{
            labelKey: 'fullName',
            identityKey: 'externalId',
            secondaryLabel: 'email'
        }"
    />
}
